import { mapActions, mapGetters, mapMutations } from 'vuex'
import { EventBus } from '@/event-bus.js'
import { BroadcastChannel } from 'broadcast-channel'

export default {
  computed: {
    ...mapGetters('notifications', [
      'fcmSupport',
      'unreadNotifications'
    ]),
    showRequestPermissionAlert () {
      if ('Notification' in window && this.browserSupportFirebaseMessagin) {
        return process.env.VUE_APP_ENABLE_LUMBRE_NOTIFICATIONS === 'yes' && Notification.permission === 'default'
      } else {
        return false
      }
    }
  },

  methods: {
    ...mapActions('notifications', [
      'requestPermission',
      'initializeNotifications',
      'getNotifications',
      'checkBrowserSupportFirebaseMessagin'
    ]),
    ...mapMutations('notifications', [
      'mutateClearUnreadNotifications'
    ]),
    hasUnreadNotifications (count) {
      if (!count) {
        document.title = this.title
        document.getElementById('favicon').href = this.favicon
        const channel = new BroadcastChannel('clearNotifications')
        channel.postMessage(true)
      } else {
        document.title = `(${this.unreadNotifications}) ${this.title}`
        document.getElementById('favicon').href = this.faviconDot
      }
    },
    // Inicia las notificaciones
    async notificationsInit () {
      this.checkBrowserSupportFirebaseMessagin()
      this.initializeNotifications()
      await this.getNotifications()

      if (process.env.VUE_APP_SOCKET_ENABLED === 'yes') {
        this.sockets.subscribe('notificationsUpdated', async _ => {
          await this.getNotifications()
        })
      }

      // Listener de notificaciones push
      EventBus.$on('onMessage', data => {
        document.getElementById('favicon').href = this.faviconDot

        this.lmToastSuccessPushNotification(data.notification.click_action, data.notification.title, data.notification.icon, data.notification.body)

        if (!process?.env?.VUE_APP_SOCKET_ENABLED) {
          setTimeout(async _ => {
            await this.getNotifications()
          }, 1000)
        }
      })

      const channel = new BroadcastChannel('clearNotifications')
      channel.onmessage = event => {
        if (event) {
          this.mutateClearUnreadNotifications()
        }
      }
    }
  },

  watch: {
    unreadNotifications (val) {
      this.hasUnreadNotifications(val)
    }
  }
}
